class CodeParachuteLightBoxPart {
    constructor(part) {
        this.SHOW_CLASS = 'show'
        this.part = part
        this.videos = part.querySelectorAll('video')
        this.images = part.querySelectorAll('img')
        const id = this.part.id
        const dataSettings = JSON.parse(this.part.getAttribute('data-settings'))
        const defaultSettings = {
            close_on_end: false
        }
        const settings = { ...defaultSettings, ...dataSettings }

        const setupButton = (buttonWrapper, direction) => {
            buttonWrapper.addEventListener('click', (e) => {
                e.stopPropagation()
                const button = buttonWrapper.querySelector('.button')
                if (!button.classList.contains('can-click')) return
                this.iterate(direction)
            })
        }
        const nextButton = this.part.querySelector('.next-button-wrapper')
        if (nextButton) setupButton(nextButton, 'next')
        const prevButton = this.part.querySelector('.prev-button-wrapper')
        if (prevButton) setupButton(prevButton, 'prev')

        
        if (this.videos?.length > 0) {
            this.videos.forEach((video) => {
                //Allow clicking video to pause/play
                video.addEventListener('click', (e) => {
                    e.stopPropagation()
                    if (video.paused) this.video.play()
                    else video.pause()
                })

                //Automatically close on end
                if (settings.close_on_end) {
                    video.addEventListener('ended', () => {
                        this.hide()
                    });
                }
            })
        }

        //Click on black area to close
        this.part.addEventListener('click', (e) => {
            e.stopPropagation()
            this.hide()
        })

        //Click on image to prevent closing
        this.images.forEach((img) => {
            img.addEventListener('click', (e) => {
                e.stopPropagation()
            })
        })

        //Find all play buttons to open lightbox
        const playButtons = document.querySelectorAll(`[data-lightbox-play="${id}"]`)
        playButtons.forEach((playButton) => {
            playButton.style.cursor = 'pointer'
            let index = playButton.getAttribute('data-lightbox-index')
            if (index) index = parseInt(index)
            else index = 0
            playButton.addEventListener('click', (e) => {
                e.stopPropagation()
                this.show(index)
            })
        })

        //Find all close buttons to close lightbox
        const closeButtons = document.querySelectorAll(`[data-lightbox-close="${id}"]`)
        closeButtons.forEach((closeButton) => {
            closeButton.style.cursor = 'pointer'
            closeButton.addEventListener('click', (e) => {
                e.stopPropagation()
                this.hide()
            })
        })
    }

    iterate(direction) {
        this.hideItem()
        const length = this.part.querySelectorAll('.media-item').length
        if (direction === 'next') {
            const nextIndex = this.currentIndex + 1  
            if (nextIndex >= length) this.currentIndex = 0
            else this.currentIndex = nextIndex
        }
        else {
            const prevIndex = this.currentIndex - 1
            if (prevIndex < 0) this.currentIndex = length - 1
            else this.currentIndex = prevIndex
        }
        this.showItem(this.currentIndex)
    }

    onKeyUp(e) {
        if (e.key === 'ArrowRight') this.iterate('next')
        else if (e.key === 'ArrowLeft') this.iterate('prev')
        else if (e.key === 'Escape') this.hide()
    }

    show(index=0) {
        this.part.classList.add(this.SHOW_CLASS)
        this.part.style.pointerEvents = 'all'
        this.showItem(index)
        BSL.get().disable(this.part)
        window.addEventListener('keyup', this.onKeyUp.bind(this))
    }

    hide() {
        this.part.classList.remove(this.SHOW_CLASS)
        this.part.style.pointerEvents = 'none'
        this.hideItem()
        BSL.get().enable(this.part)
        window.removeEventListener('keyup', this.onKeyUp.bind(this))
    }

    showItem(index) {
        const item = this.part.querySelectorAll('.media-item')[index]
        if (item) {
            item.style.display = 'flex'
            this.currentIndex = index
            const video = item.querySelector('video')
            if (video) video.play()
            const itemIndex = this.part.querySelector('.item-index')
            if (itemIndex) itemIndex.innerHTML = `${index + 1}/${this.part.querySelectorAll('.media-item').length}`
        }
    }

    hideItem() {
        const item = this.part.querySelectorAll('.media-item')[this.currentIndex]
        if (item) {
            item.style.display = 'none'
            const video = item.querySelector('video')
            if (video) {
                video.pause()
                video.currentTime = 0;
            }
        }
    }

    toggle() {
        if (this.part.classList.contains(this.SHOW_CLASS)) this.hide()
        else this.show()
    }
}

document.querySelectorAll('.codeparachute-light-box-part').forEach((part) => new CodeParachuteLightBoxPart(part))
